module.exports = __webpack_public_path__ + "static/media/hp_2.2f29f87e.png";